class Accordeon {
    static init() {
        this.blocs = document.querySelectorAll(".flexaccordeon");

        this.blocs.forEach(bloc => {
            bloc.items = bloc.querySelectorAll(".flexaccordeon__item");
            bloc.items.forEach(item => {
                item.button = item.querySelector(".flexaccordeon__item__toggle");
                item.button.addEventListener("click", () => this.toggle(bloc, item));

                item.titre = item.querySelector(".flexaccordeon__item__titre");
                item.titre.addEventListener("click", () => this.toggle(bloc, item));
            });
        });
    }

    static toggle(bloc, thisItem) {
        bloc.items.forEach(item => {
            item.style.height = "";
            item.currentHeight = item.getBoundingClientRect().height;

            if (thisItem === item && !item.classList.contains("flexaccordeon__item--open")) {
                item.nextAction = "add";
                item.classList.add("flexaccordeon__item--open");
                item.nextHeight = item.getBoundingClientRect().height;
                item.classList.remove("flexaccordeon__item--open");
            } else if(item.classList.contains("flexaccordeon__item--open")) {
                item.nextAction = "remove";
                item.classList.remove("flexaccordeon__item--open");
                item.nextHeight = item.getBoundingClientRect().height;
                item.classList.add("flexaccordeon__item--open");
            }

            item.style.height = item.currentHeight + "px";
            setTimeout(() => {
                item.style.height = item.nextHeight + "px"
            }, 50);
            if (item.nextAction === "remove") {
                setTimeout(() => {
                    item.classList[item.nextAction]("flexaccordeon__item--open");
                }, 500);
            } else if (item.nextAction === "add"){
                item.classList[item.nextAction]("flexaccordeon__item--open");
            }
        })
    }
}

export default Accordeon;


// WEBPACK FOOTER //
// ./src/scripts/components/accordeon.js